import axiosInstance, { microServices } from 'network/apis/index'
import { METHOD_TYPES } from 'utils/constants/index'

export const sendChatMessageService = (data) => {
  return axiosInstance(METHOD_TYPES.post, 'user/chat', data, {
    server: microServices.USER_URL
  })
}

export const getChatsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, 'user/get-chat', {}, {
    server: microServices.USER_URL,
    params
  })
}
